/**
 * Enum object for all possible {@link Feature} IDs
 */
export enum FeatureID {
  LoginOnBehalfOf = 'loginOnBehalfOf',
  AdministratorOf = 'administratorOf',
  CanDelete = 'canDelete',
  CanEditMetadata = 'canEditMetadata',
  WithdrawItem = 'withdrawItem',
  ReinstateItem = 'reinstateItem',
  EPersonRegistration = 'epersonRegistration',
  CanManageGroups = 'canManageGroups',
  CanManageGroup = 'canManageGroup',
  IsCollectionAdmin = 'isCollectionAdmin',
  IsCommunityAdmin = 'isCommunityAdmin',
  CanChangePassword = 'canChangePassword',
  CanDownload = 'canDownload',
  CanRequestACopy = 'canRequestACopy',
  CanManageVersions = 'canManageVersions',
  CanManageBitstreamBundles = 'canManageBitstreamBundles',
  CanManageRelationships = 'canManageRelationships',
  CanManageMappings = 'canManageMappings',
  CanManagePolicies = 'canManagePolicies',
  CanMakePrivate = 'canMakePrivate',
  CanMove = 'canMove',
  CanEditVersion = 'canEditVersion',
  CanDeleteVersion = 'canDeleteVersion',
  CanCreateVersion = 'canCreateVersion',
  CanViewUsageStatistics = 'canViewUsageStatistics',
  CanViewLoginStatistics = 'canViewLoginStatistics',
  CanViewWorkflowStatistics = 'canViewWorkflowStatistics',
  CanSendFeedback = 'canSendFeedback',
  CanClaimItem = 'canClaimItem',
  CanSynchronizeWithORCID = 'canSynchronizeWithORCID',
  CanSubmit = 'canSubmit',
  CanEditItem = 'canEditItem',
  CanRegisterDOI = 'canRegisterDOI',
  CanSubscribe = 'canSubscribeDso',
  CoarNotifyEnabled = 'coarNotifyEnabled',
  CanSeeQA = 'canSeeQA',
  EPersonForgotPassword = 'epersonForgotPassword',
  ShowClaimItem = 'showClaimItem',
  CanCorrectItem = 'canCorrectItem',
  CanViewInWorkflowSinceStatistics = 'canViewInWorkflowSinceStatistics',
}
